// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************

const GET_FINANCIAL_PAYROLL_SUCCESS = "GET_FINANCIAL_PAYROLL_SUCCESS";
const GET_SALARY_SLIP_SUCCESS = "GET_SALARY_SLIP_SUCCESS";
const GET_SALARY_SLIP_ERROR = "GET_SALARY_SLIP_ERROR";
const UPLOAD_EXCEL_SUCCESS = "UPLOAD_EXCEL_SUCCESS";
const UPLOAD_EXCEL_ERROR = "UPLOAD_EXCEL_ERROR";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getFileSuccess(payload) {
  return {
    type: GET_FINANCIAL_PAYROLL_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getSalarySlipSuccess(payload) {
  return {
    type: GET_SALARY_SLIP_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{error: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getSalarySlipError(payload) {
  return {
    type: GET_SALARY_SLIP_ERROR,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _uploadExcelSuccess(payload) {
  return {
    type: UPLOAD_EXCEL_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{error: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _uploadExcelError(payload) {
  return {
    type: UPLOAD_EXCEL_ERROR,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************
/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function checkFile(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/financial/payroll/check_file", {
        data: {
          props: {
            year: data.year,
            month: data.month,
          },
        },
        responseType: "blob",
      })
        .then((res) => {
          const url = URL.createObjectURL(res);
          // const link = document.createElement("a");
          // link.href = url;
          if (res.type.includes("pdf")) {
            dispatch(_getFileSuccess(url));
            callback(undefined, url);
          } else {
            dispatch(_getFileSuccess("اطلاعاتی جهت نمایش موجود نیست!"));
            callback(undefined, "اطلاعاتی جهت نمایش موجود نیست!");
          }
        })
        .catch((err) => {
          callback(err && err.response);
        });
  };
}

/**
 * Get salary slip data from API
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getSalarySlip(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    const requestPayload = {
      data: {
        PersonId: data.PersonId, // This should come from current user if needed
        year: parseInt(data.year),
        month: parseInt(data.month),
      },
    };
      console.log("Asd",data);
      
      console.group("📤 Getting Salary Slip from API");
      console.log("🔗 API Endpoint:", "/SalarySlips/GetSalarySlip");
      console.log("📅 Year:", data.year);
      console.log("📅 Month:", data.month);
      console.log("📋 Request Payload:", requestPayload);
      console.groupEnd();

      api
        .post("/SalarySlips/GetSalarySlip", requestPayload)
        .then((res) => {
          console.group("✅ Salary Slip - Success Response");
          console.log("📨 Response Data:", res.data);
          console.log("📊 Response Status:", res.status);
          console.groupEnd();
          
          dispatch(_getSalarySlipSuccess(res.data));
          callback(undefined, res.data);
        })
        .catch((err) => {
          console.group("❌ Salary Slip - Error Response");
          console.log("🚨 Error:", err);
          console.log("📝 Error Response Data:", err.response?.data);
          console.log("📊 Error Status:", err.response?.status);
          console.groupEnd();
          
          dispatch(_getSalarySlipError(err.response?.data || err));
          callback(err && err.response);
        });
  };
}

/**
 * Upload Excel file to backend
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function uploadExcelFile(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    // نمایش داده‌های ارسالی در کنسول
    const requestPayload = {
      data: {
         
          // fileName: data.fileName,
          ExcelBase64: data.fileData,
          year: +data.year,
          month: +data.month,
        },
    };

      console.group("📤 Excel Upload - Sending to Backend");
      console.log("🔗 API Endpoint:", "/SalarySlips/ImportExcel");
      console.log("📄 File Name:", data.fileName);
      console.log("📅 Year:", data.year);
      console.log("📅 Month:", data.month);
      console.log("📦 File Data (Base64) Length:", data.fileData ? data.fileData.length : 0);
      console.log("📋 File Data Preview (First 100 chars):", data.fileData ? data.fileData.substring(0, 100) + "..." : "No data");
      console.log("✅ Base64 Data Validation:", data.fileData ? "Valid Base64 String" : "❌ No Base64 Data");
      console.log("🔍 Base64 Format Check:", data.fileData && /^[A-Za-z0-9+/=]+$/.test(data.fileData) ? "✅ Valid Format" : "❌ Invalid Format");
      console.log("🗂️ Complete Request Payload:", requestPayload);
      console.groupEnd();

      api
        .post("/SalarySlips/ImportExcel", requestPayload)
        .then((res) => {
          console.group("✅ Excel Upload - Success Response");
          console.log("📨 Response Data:", res.data);
          console.log("📊 Response Status:", res.status);
          console.groupEnd();
          
          dispatch(_uploadExcelSuccess(res.data));
          callback(undefined, res);
        })
        .catch((err) => {
          console.group("❌ Excel Upload - Error Response");
          console.log("🚨 Error:", err);
          console.log("📝 Error Response Data:", err.response?.data);
          console.log("📊 Error Status:", err.response?.status);
          console.groupEnd();
          
          dispatch(_uploadExcelError(err.response?.data || err));
          callback(err && err.response);
        });
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    payroll: {},
    salarySlipData: null,
    salarySlipError: null,
    uploadResult: null,
    uploadError: null,
  },
  action
) {
  switch (action.type) {
    case GET_FINANCIAL_PAYROLL_SUCCESS:
      return Object.assign({}, state, {
        payroll: action.payload,
      });
    case GET_SALARY_SLIP_SUCCESS:
      console.log("🔄 Reducer - GET_SALARY_SLIP_SUCCESS:", action.payload);
      return Object.assign({}, state, {
        salarySlipData: action.payload,
        salarySlipError: null,
      });
    case GET_SALARY_SLIP_ERROR:
      console.log("❌ Reducer - GET_SALARY_SLIP_ERROR:", action.payload);
      return Object.assign({}, state, {
        salarySlipError: action.payload,
        salarySlipData: null, // Clear data on error
      });
    case UPLOAD_EXCEL_SUCCESS:
      return Object.assign({}, state, {
        uploadResult: action.payload,
        uploadError: null,
      });
    case UPLOAD_EXCEL_ERROR:
      return Object.assign({}, state, {
        uploadError: action.payload,
        uploadResult: null,
      });
    default:
      return state;
  }
}
// {
//     "activites": [
//         {
//             "title": "کارکرد روزانه",
//             "amount": "31"
//         },
//         {
//             "title": "هزينه سفر و فوق العاده مسافرت",
//             "amount": "0"
//         },
//         {
//             "title": "اضافه کاري .",
//             "amount": "000:00"
//         },
//         {
//             "title": "اضافه کاري تشويقي .",
//             "amount": "0"
//         },
//         {
//             "title": "مرخصي استحقاقي",
//             "amount": "0"
//         },
//         {
//             "title": "مرخصي استعلاجي",
//             "amount": "0"
//         },
//         {
//             "title": "مرخصي بدون حقوق",
//             "amount": "0"
//         },
//         {
//             "title": "غيبت روزانه",
//             "amount": "0"
//         },
//         {
//             "title": "مرخصي ساعتي1",
//             "amount": "0000:00"
//         },
//         {
//             "title": "تاخير",
//             "amount": "000:00"
//         },
//         {
//             "title": "تعجيل",
//             "amount": "000:00"
//         }
//     ],
//     "deductions": [
//         {
//             "title": "صندوق پرسنل",
//             "amount": "0"
//         },
//         {
//             "title": "وام صندوق قرض الحسنه",
//             "amount": "0"
//         },
//         {
//             "title": "وام صندوق خدمات پس از فروش",
//             "amount": "0"
//         },
//         {
//             "title": "وام داخلي",
//             "amount": "0"
//         },
//         {
//             "title": "جمع مساعده",
//             "amount": "0"
//         },
//         {
//             "title": "هزينه رب مازاد.",
//             "amount": "0"
//         },
//         {
//             "title": "کسر از حقوق",
//             "amount": "0"
//         },
//         {
//             "title": "مازاد بيمه",
//             "amount": "0"
//         },
//         {
//             "title": "هزينه برنج",
//             "amount": "0"
//         },
//         {
//             "title": "هزينه ي مصرف شخصي",
//             "amount": "0"
//         },
//         {
//             "title": "خلافي ماشين ها",
//             "amount": "0"
//         },
//         {
//             "title": "مابه تفاوت مالیات مرداد",
//             "amount": "0"
//         },
//         {
//             "title": "کسر هزينه غذا",
//             "amount": "0"
//         },
//         {
//             "title": "کسر مانده تن خواه",
//             "amount": "0"
//         },
//         {
//             "title": "کسر بيمه تکميلي",
//             "amount": "7500000"
//         },
//         {
//             "title": "کسر بدهي دوره قبل",
//             "amount": "0"
//         },
//         {
//             "title": "حق ماليات",
//             "amount": "0"
//         },
//         {
//             "title": "حق بيمه",
//             "amount": "24391774"
//         }
//     ],
//     "benefits": [
//         {
//             "title": "حقوق ماهيانه",
//             "amount": "304641566"
//         },
//         {
//             "title": "هزينه سفر و فوق العاده مسافرت.",
//             "amount": "0"
//         },
//         {
//             "title": "حق اضافه کاري",
//             "amount": "0"
//         },
//         {
//             "title": "حق اضافه کار تشويقي",
//             "amount": "0"
//         },
//         {
//             "title": "حق  مسکن",
//             "amount": "9000000"
//         },
//         {
//             "title": "حق خوارو بار",
//             "amount": "22000000"
//         },
//         {
//             "title": "حق اولاد",
//             "amount": "10390968"
//         },
//         {
//             "title": "حق تاهل",
//             "amount": "0"
//         },
//         {
//             "title": "حق سرپرستي",
//             "amount": "12812342"
//         },
//         {
//             "title": "هزينه سفر",
//             "amount": "255000000"
//         },
//         {
//             "title": "پاداش",
//             "amount": "0"
//         },
//         {
//             "title": "پايش ماهانه",
//             "amount": "0"
//         },
//         {
//             "title": "شبکاري",
//             "amount": "0"
//         },
//         {
//             "title": "تشويقي شبکاري",
//             "amount": "0"
//         },
//         {
//             "title": "هزينه غذا",
//             "amount": "0"
//         },
//         {
//             "title": "کرايه",
//             "amount": "0"
//         },
//         {
//             "title": "شارژ تلفن همراه",
//             "amount": "0"
//         },
//         {
//             "title": "هديه تولد",
//             "amount": "0"
//         },
//         {
//             "title": "هديه تولد فرزند",
//             "amount": "0"
//         },
//         {
//             "title": "مابه تفاوت مالیات مرداد",
//             "amount": "0"
//         },
//         {
//             "title": "مانده حقوق از ماه قبل",
//             "amount": "0"
//         },
//         {
//             "title": "روند دوره قبل",
//             "amount": "368"
//         }
//     ],
//     "considerations": [
//         {
//             "title": "مانده مرخصی",
//             "amount": "15:0:00"
//         }
//     ],
//     "net_receipts": 606345000,
//     "sum_deduction": 7500000,
//     "sum_benefits": 613844876,
//     "month": 2,
//     "year": 1403,
//     "full_name": "سید مهدی پورانواری",
//     "personnel_id": "113"
// }